/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Table_CheapestInputs */

const en_platform_table_cheapest = /** @type {(inputs: Platform_Table_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheapest`)
};

const zh_hans1_platform_table_cheapest = /** @type {(inputs: Platform_Table_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最低价`)
};

const pt_br2_platform_table_cheapest = /** @type {(inputs: Platform_Table_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais barato`)
};

const es_platform_table_cheapest = /** @type {(inputs: Platform_Table_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más barato`)
};

const fr_platform_table_cheapest = /** @type {(inputs: Platform_Table_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le moins cher`)
};

const de_platform_table_cheapest = /** @type {(inputs: Platform_Table_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günstigster`)
};

const ru_platform_table_cheapest = /** @type {(inputs: Platform_Table_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самые дешёвые`)
};

const it_platform_table_cheapest = /** @type {(inputs: Platform_Table_CheapestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Più economico`)
};

/**
* | output |
* | --- |
* | "Cheapest" |
*
* @param {Platform_Table_CheapestInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_table_cheapest = /** @type {((inputs?: Platform_Table_CheapestInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Table_CheapestInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_table_cheapest(inputs)
	if (locale === "pt-BR") return pt_br2_platform_table_cheapest(inputs)
	if (locale === "es") return es_platform_table_cheapest(inputs)
	if (locale === "fr") return fr_platform_table_cheapest(inputs)
	if (locale === "de") return de_platform_table_cheapest(inputs)
	if (locale === "ru") return ru_platform_table_cheapest(inputs)
	if (locale === "it") return it_platform_table_cheapest(inputs)
	return en_platform_table_cheapest(inputs)
});